module.exports = __webpack_public_path__ + "static/media/Flaticon.afa21cbe.svg";